import type { SpotifyEpisode } from '@/utilities/spotify'
import { PodcastCard } from './PodcastCard'
import { Headphones, ArrowRight } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { InstagramFeed } from '@/components/instagram/InstagramFeed'

type Props = {
  episodes: SpotifyEpisode[]
}

export const PodcastGrid = ({ episodes }: Props) => {
  if (episodes.length === 0) return null

  return (
    <section className="pt-16 pb-8 md:pt-24 md:pb-12" aria-label="Podcast" id="podcast-section">
      <div className="container">
        <div className="grid gap-12 lg:grid-cols-3">
          {/* Left column: Podcasts (2/3 width) */}
          <div className="flex flex-col lg:col-span-2">
            <div className="mb-8 flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
              <div className="space-y-3">
                <p className="text-xs font-semibold uppercase tracking-[0.3em] text-primary">
                  Podcast
                </p>
                <h2 className="text-3xl font-bold tracking-tight text-foreground md:text-4xl">
                  Laatste afleveringen
                </h2>
                <p className="max-w-lg text-muted-foreground">
                  Luister naar onze nieuwste podcast afleveringen over voeding, sport en leefstijl.
                </p>
              </div>
            </div>

            <div className="grid flex-1 gap-8 sm:grid-cols-2">
              {episodes.map((episode) => (
                <PodcastCard episode={episode} key={episode.id} />
              ))}
            </div>

            <div className="mt-auto pt-8">
              <Button asChild variant="outline" className="rounded-full">
                <a
                  href="https://open.spotify.com/show/6j3hD1KDEDiKp1IvhMOc7V"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2"
                >
                  <Headphones className="h-4 w-4" />
                  Bekijk alle afleveringen
                  <ArrowRight className="h-4 w-4" />
                </a>
              </Button>
            </div>
          </div>

          {/* Right column: Instagram */}
          <div className="flex flex-col">
            <InstagramFeed />
          </div>
        </div>
      </div>
    </section>
  )
}
